{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/avatar",
	"title": "Avatar",
	"category": "theme",
	"description": "Add a user’s avatar.",
	"textdomain": "default",
	"attributes": {
		"userId": {
			"type": "number"
		},
		"size": {
			"type": "number",
			"default": 96
		},
		"isLink": {
			"type": "boolean",
			"default": false
		},
		"linkTarget": {
			"type": "string",
			"default": "_self"
		}
	},
	"usesContext": [ "postType", "postId", "commentId" ],
	"supports": {
		"anchor": true,
		"html": false,
		"align": true,
		"alignWide": false,
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"__experimentalBorder": {
			"__experimentalSkipSerialization": true,
			"radius": true,
			"width": true,
			"color": true,
			"style": true,
			"__experimentalDefaultControls": {
				"radius": true
			}
		},
		"color": {
			"text": false,
			"background": false
		},
		"filter": {
			"duotone": true
		},
		"shadow": {
			"__experimentalSkipSerialization": true
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"selectors": {
		"border": ".wp-block-avatar img",
		"shadow": ".wp-block-avatar img",
		"filter": {
			"duotone": ".wp-block-avatar img"
		}
	},
	"editorStyle": "wp-block-avatar-editor",
	"style": "wp-block-avatar"
}
